import { z } from 'zod';

//--------------------------------
// Zod Schema
//--------------------------------
const logosSchema = z.object({
    lightSymbol: z.string(),
    darkSymbol: z.string(),
    lightFull: z.string(),
    darkFull: z.string(),
    favicon: z.string().optional(),
});

export { logosSchema };
//# sourceMappingURL=Logos.js.map
